export default __webpack_public_path__ + "static/media/wos_import.aba5aad1.mp4";